import {
  Box,
  Container,
  Divider,
  Grid,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from '@mui/material'
import { useSearchParams } from 'react-router-dom'

import src from '../assets/ssk.png'
import srcDark from '../assets/loggoDarkMode.png'
import Loading from '../core/views/loading'
import HomeWorkout from '../components/home-workout'
import PublicWorkoutCalendar from '../components/public-workout-calendar'
import { useAuth } from '../core/providers/auth'
import { useWorkouts, Workout } from '../providers/workouts'
import { GetDisplayDate } from '../hooks/timestamp'
import Filter from '../components/filter/filter'
import { useFilters } from '../providers/filterprovider'

export default function Home() {
  const { user, admin } = useAuth()
  const { loading, workoutsOnDate } = useWorkouts()
  const { filters } = useFilters()
  const [searchParams, setSearchParams] = useSearchParams()
  const viewMode =
    searchParams.get('view') === 'calendar' ? 'calendar' : 'list'

  const filterWorkout = (w: Workout) => {
    let matched: boolean[] = []
    filters.forEach((filter) => {
      if (filter.filteredData.length < 1) {
        matched.push(true)
      } else if (filter.filteredData.some((f) => filter.filterMatchCallBack(w, f))) {
        matched.push(true)
      } else {
        matched.push(false)
      }
    })
    
    return matched.every((m) => m === true)
  }

  const today = new Date()
  const todayStart = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate()
  )

  const visibleWorkoutDays = workoutsOnDate
    .filter((wd) => wd.date >= todayStart)
    .map((wd) => {
      const filteredWorkouts = wd.workouts.filter((w) => filterWorkout(w))

      if (filteredWorkouts.length > 0) {
        return {
          date: wd.date,
          workouts: filteredWorkouts,
        }
      }

      return null
    })
    .filter((wd): wd is NonNullable<typeof wd> => wd !== null)

  const visibleCalendarWorkouts = visibleWorkoutDays.reduce<Workout[]>(
    (acc, wd) => acc.concat(wd.workouts),
    []
  )

  if (loading) return <Loading />

  return (
    <Container>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          marginTop: 4,
        }}
      >
        <Box
          sx={{
            width: 45,
            height: 45,
          }}
        >
          <img
            style={{ maxWidth: '100%' }}
            src={user?.theme === 'light' ? src : srcDark}
            alt="Sunderby Sportklubb"
          />
        </Box>
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
        }}
      >
        <Filter />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            py: 2,
          }}
        >
          <ToggleButtonGroup
            exclusive
            value={viewMode}
            onChange={(_, nextView) => {
              if (nextView) {
                const nextParams = new URLSearchParams(searchParams)
                nextParams.set('view', nextView)
                setSearchParams(nextParams, { replace: true })
              }
            }}
            size="small"
            color="primary"
          >
            <ToggleButton value="list">Standardvy</ToggleButton>
            <ToggleButton value="calendar">Kalendervy</ToggleButton>
          </ToggleButtonGroup>
        </Box>
        <Divider />
        {visibleWorkoutDays.length > 0 ? (
          viewMode === 'calendar' ? (
            <PublicWorkoutCalendar workouts={visibleCalendarWorkouts} />
          ) : (
            visibleWorkoutDays.map((wd, key) => (
              <Grid key={key} container spacing={1} justifyContent="flex-start">
                <Grid item xs={12}>
                  <h3>{GetDisplayDate(wd.date)}</h3>
                </Grid>
                {wd.workouts.map((w, workoutKey) => (
                  <Grid key={workoutKey} item xs={12} sm={6}>
                    <HomeWorkout workout={w} />
                  </Grid>
                ))}
              </Grid>
            ))
          )
        ) : (
          <Typography
            sx={{ textAlign: 'center', marginTop: '2rem', fontWeight: 'bold' }}
          >
            För närvarande inga pass att visa
          </Typography>
        )}
      </Box>
      <Box sx={{ height: admin ? 104 : 72 }} />
    </Container>
  )
}
